import httpService from "./httpService";

export const fournisseurService = {
  query,
  getById,
  save,
  remove,
  migrateFromAdmin,
};

function query() {
  return httpService.get("fournisseurs");
}

function getById(fournisseurId) {
  return httpService.get(`fournisseurs/${fournisseurId}`);
}

function remove(fournisseurId) {
  return httpService.delete(`fournisseurs/${fournisseurId}`);
}

function save(fournisseur) {
  if (fournisseur._id) {
    return httpService.put(`fournisseurs/${fournisseur._id}`, fournisseur);
  }
  return httpService.post("fournisseurs", fournisseur);
}

function migrateFromAdmin() {
  return httpService.post("fournisseurs/migrate-from-admin");
}
